import React, { useContext } from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import { ThemeContext } from '../../contexts/ThemeContext';

export interface ITableDicaHintProps {
    text: string;
    icon?: React.ReactNode;
    style?: React.CSSProperties;
}

export default function TableDicaHint({
    text,
    icon = <InfoCircleOutlined style={{ fontSize: 13, color: '#1677ff' }} />,
    style,
}: ITableDicaHintProps) {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === 'dark';

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                fontSize: 12,
                color: isDark ? '#888888' : '#64748b',
                padding: '0 4px',
                ...style,
            }}
        >
            {icon}
            <span>{text}</span>
        </div>
    );
}
